import ImageCollectionPage from "../components/ImageCollectionPage";

export default function NamingCeremony() {
  return <ImageCollectionPage title="Naming Ceremony" path="/culture/naming" collection="culture_naming" />;
}
